// Extracts the value of the p tags based on the value of a master tag above it (h2 for most cases).
export function extractFromPTagsFromRawText(rawString, tag, tagValue) {
    const regex = new RegExp(`<${tag}(.*?)>(.*?)<\/${tag}>(((\\\\[a-z])*?)|((\\s)*?))(<p(.*?)>)(.*?)(<\/p>)`, "gim");
    const matchedDetails = rawString.match(regex);
    if (matchedDetails == null)
        return;
    let matchedText = null;
    matchedDetails.forEach(element => {
        const elem = document.createElement('div');
        elem.innerHTML = element;
        if (elem.querySelector(tag).textContent.toLowerCase().includes(tagValue.toLowerCase())) {
            matchedText = elem.querySelector("p").innerHTML;
        }
    });
    return matchedText;
}
// Fetches all pages in a WordPress category
export async function fetchMultiplePages(source) {
    let combinedResponse = [];
    let breakLoop = false;
    for (let i = 1; !breakLoop; i++) {
        const response = await fetch(`${source}&page=${i}&per_page=50`);
        const json = await response.json();
        if (json["code"] === "rest_post_invalid_page_number" || !Array.isArray(json)) {
            breakLoop = true;
        }
        else {
            combinedResponse = [...combinedResponse, ...json];
        }
    }
    return combinedResponse;
}
// Loads image with a fallback image and checks for both JPG and PNG. Makes sure that there always is an image the user sees.
export async function loadImageWithFallback(path, fallback, JPGPriority = true) {
    return await (new Promise((resolve, reject) => {
        // See if a jpeg with name exits
        const img = new Image();
        img.src = (JPGPriority) ? `${path}.jpg` : `${path}.png`;
        img.onload = () => resolve((JPGPriority) ? `${path}.jpg` : `${path}.png`);
        img.onerror = () => {
            // If JPEG doesnt exist then check if PNG exists
            const img = new Image();
            img.src = (JPGPriority) ? `${path}.png` : `${path}.jpg`;
            img.onload = () => resolve((JPGPriority) ? `${path}.png` : `${path}.jpg`);
            img.onerror = () => reject(`image not found, falling back`);
        };
    }).catch(() => fallback)); // If both dont exist then use placeholder image
}
